export enum DAWType {
  ABLETON = 'ableton',
  LOGIC = 'logic',
  PRO_TOOLS = 'protools',
  CUBASE = 'cubase',
  FL_STUDIO = 'flstudio',
  REAPER = 'reaper',
  STEMS = 'stems',
  UNKNOWN = 'unknown',
}

export const DAW_EXTENSIONS: Record<
  string,
  { type: DAWType; contentType: string }
> = {
  '.als': { type: DAWType.ABLETON, contentType: 'application/octet-stream' },
  '.logicx': { type: DAWType.LOGIC, contentType: 'application/octet-stream' },
  '.ptf': { type: DAWType.PRO_TOOLS, contentType: 'application/octet-stream' },
  '.ptx': { type: DAWType.PRO_TOOLS, contentType: 'application/octet-stream' },
  '.cpr': { type: DAWType.CUBASE, contentType: 'application/octet-stream' },
  '.flp': { type: DAWType.FL_STUDIO, contentType: 'application/octet-stream' },
  '.rpp': { type: DAWType.REAPER, contentType: 'application/octet-stream' },
};
